import React from 'react';
import { Loader } from '@trackman/web-shared-components';
import styled from 'styled-components';

export const Title = styled.div`
  font-weight: 700;
`;

export const Label = styled.div`
  color: #a0a0a0;
`;

export const Note = styled.div`
  padding: 8px 12px;
  background-color: rgba(254, 152, 0, 0.1);
  color: #717171;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #fe9800;
  border-radius: 4px;
`;

export const SingleItem = styled.div`
  display: flex;
  gap: 8px;
`;

export const Content = styled.div<{ isLoading: boolean }>`
  padding: 24px 23px 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 15px;
  font-family: 'Lato';
  filter: ${(props) => (props.isLoading ? 'blur(2px)' : 'none')};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

export const SubmitButtonWrapper = styled.div`
  .MuiTooltip-tooltip .MuiTooltip-arrow {
    color: #fff !important;
  }
  .MuiTooltip-tooltip {
    background-color: #fff !important;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
  }

  .MuiTooltip-tooltip {
    color: #414141 !important;
  }
`;

export const LoaderOverlay = styled.div`
  .MuiCircularProgress-root {
    position: absolute;
    top: calc(50% - 56px / 2);
    left: calc(50% - 56px / 2);
    transform: translate(-50%, -50%);
  }
`;
